module.exports = __webpack_public_path__ + "static/media/user-visit.8d01e063.mp3";